import { useState, useEffect } from 'react'
import { getSearchUsernameAPI } from '../services/right-org'
import { getSearchAssetITAPI } from '../services/property'

function UseEmpsUserAssetIT( search) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const body = {
        // orgId,
        searchs: search ?? ''
      }
      const result = await getSearchAssetITAPI(body)
      if (!result) return
      if (result.status) {
        const newData = result.result.map((d, i) => {
          return {
            value: d?.username,
            uuid: d?.uuid,
            orgId: d?.org_id,
            label: `${d?.org ?? ""} - ${d?.code ?? ""} - ${d?.username ?? ""} `
          }
        })
        setData(newData)
      }
    }
    getData()
  }, [search])

  return data
}

export default UseEmpsUserAssetIT
